import { useQuery } from "@sveltestack/svelte-query";

const END_POINT = "/api/license/e-protector"

export function useEProtectorLicenseAuthenticationResultQuery(options) {
  return useQuery(END_POINT, options)
}
